var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PinwheelOut = exports.PinwheelIn = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_5834865852801_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{scale:delayFunction(delay,animation(1,config))},{rotate:delayFunction(delay,animation('0',config))}]},initialValues:{opacity:0,transform:[{scale:0},{rotate:'5'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Pinwheel.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","scale","rotate"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Pinwheel.ts"],"mappings":"AAwBW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CACEC,KAAK,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAClD,CAAC,CACD,CACEQ,MAAM,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CACrD,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CACEC,KAAK,CAAE,CACT,CAAC,CACD,CACEC,MAAM,CAAE,GACV,CAAC,CACF,CACD,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var PinwheelIn = exports.PinwheelIn = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(PinwheelIn, _ComplexAnimationBuil);
    var _super = _createSuper(PinwheelIn);
    function PinwheelIn() {
        var _this;
        (0, _classCallCheck2.default)(this, PinwheelIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    scale: delayFunction(delay, animation(1, config))
                                },
                                {
                                    rotate: delayFunction(delay, animation("0", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    scale: 0
                                },
                                {
                                    rotate: "5"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_5834865852801_init_data;
                anonymous.__workletHash = 5834865852801;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(PinwheelIn, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new PinwheelIn();
            }
        }
    ]);
    return PinwheelIn;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_12877566329953_init_data = {
    code: "function anonymous(){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{scale:delayFunction(delay,animation(0,config))},{rotate:delayFunction(delay,animation('5',config))}]},initialValues:{opacity:1,transform:[{scale:1},{rotate:'0'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Pinwheel.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","scale","rotate"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Pinwheel.ts"],"mappings":"AAyEW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CACEC,KAAK,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAClD,CAAC,CACD,CACEQ,MAAM,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CACrD,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CACEC,KAAK,CAAE,CACT,CAAC,CACD,CACEC,MAAM,CAAE,GACV,CAAC,CACF,CACD,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var PinwheelOut = exports.PinwheelOut = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(PinwheelOut, _ComplexAnimationBuil2);
    var _super2 = _createSuper(PinwheelOut);
    function PinwheelOut() {
        var _this2;
        (0, _classCallCheck2.default)(this, PinwheelOut);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    scale: delayFunction(delay, animation(0, config))
                                },
                                {
                                    rotate: delayFunction(delay, animation("5", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    scale: 1
                                },
                                {
                                    rotate: "0"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_12877566329953_init_data;
                anonymous.__workletHash = 12877566329953;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(PinwheelOut, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new PinwheelOut();
            }
        }
    ]);
    return PinwheelOut;
}(_animationBuilder.ComplexAnimationBuilder);
